import { render, staticRenderFns } from "./movimientos_inventario.vue?vue&type=template&id=001bc5e3&"
import script from "./movimientos_inventario.vue?vue&type=script&lang=js&"
export * from "./movimientos_inventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports